module.exports = __webpack_public_path__ + "img/4w.b133db24.svg";